export const PRINT_API_BASE = process.env.REACT_APP_PRINT_API_BASE_URL || 'http://localhost:5001';

export function printApiUrl(path) {
  return `${PRINT_API_BASE}${path}`;
}
